
import { CompanyInfoCurrent, Events } from "@/api";
import { CurrentCompanyInfo } from "@/api/types";
import GoogleAddressAutocomplete from "@/components/common/GoogleAddressAutocomplete.vue";
import PageTitle from "@/components/common/PageTitle.vue";
import { GooglePlace } from "@/utils/googleMaps";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    PageTitle,
    GoogleAddressAutocomplete
  }
})
export default class CompanyInfo extends Vue {
  headersTitle = [{ icon: "mdi-border-color", header: "Edit Company Info" }];
  companyInfo: CurrentCompanyInfo = {
    address: "",
    placeId: null,
    name: null,
    lat: null,
    lng: null
  };
  currentId: number | null = null;

  onAddressSelect(place: GooglePlace): void {
    this.companyInfo.address = place.address;
    this.companyInfo.placeId = place.placeId;
    this.companyInfo.name = place.name;
    this.companyInfo.lat = place.lat;
    this.companyInfo.lng = place.lng;
  }
  async created() {
    const adr = await Events.getOfficeAddress();
    this.currentId = adr.data[0].id;
    this.companyInfo.address = adr.data[0].address;
  }
  async save() {
    try {
      if (this.currentId) {
        await CompanyInfoCurrent.submitCompanyInfo(
          this.companyInfo,
          this.currentId
        );
        await this.$success(
          "<strong>Success!</strong> Company Info has been updated!"
        );
      } else {
        await CompanyInfoCurrent.createCompanyInfo(this.companyInfo);
        await this.$success(
          "<strong>Success!</strong> Company Info has been created!"
        );
      }
    } catch (e) {
      (this.$refs.companyForm as Vue & {
        setErrors: (errors: any) => void;
      }).setErrors(e.errors);
      await this.$error(e.errors);
    }
  }
}
